var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.7844C18.4956 10.2642 21 8.86049 21 7.21053C21 5.11766 16.9706 2 12 2C7.02944 2 3 5.11766 3 7.21053C3 8.86049 5.50442 10.2642 9 10.7844V11.6967C9.11696 11.7408 9.2494 11.7872 9.39743 11.8351C9.91257 12.0016 10.5566 12.1664 11.2636 12.3016C12.4766 12.5337 13.8282 12.6698 15 12.5979V10.7844Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.3004C13.6947 14.3707 12.2583 14.2164 11.014 13.9783C10.267 13.8354 9.57332 13.6593 9 13.4748V15.9947C9.17354 16.0858 9.46243 16.2066 9.86867 16.3379C10.3838 16.5044 11.0279 16.6692 11.7348 16.8044C12.7882 17.0059 13.9461 17.1351 15 17.1185V14.3004Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.981 18.8192C13.8132 18.834 12.5755 18.6897 11.4852 18.4811C10.7322 18.3371 10.0334 18.1593 9.45737 17.9731C9.30013 17.9223 9.14661 17.8692 9 17.8139V18.5992C9 18.8999 9.10536 19.1882 9.29289 19.4008L11.2929 21.668C11.6834 22.1107 12.3166 22.1107 12.7071 21.668L14.7071 19.4008C14.8482 19.2408 14.9428 19.038 14.981 18.8192Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrew);
export default __webpack_public_path__ + "static/media/screw.bb4cb5f754e882640f6c06eb7fb7e377.svg";
export { ForwardRef as ReactComponent };